"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbnPicker = void 0;
var react_1 = __importStar(require("react"));
var async_1 = __importDefault(require("react-select/async"));
var react_select_1 = require("react-select");
var fetch_jsonp_1 = __importDefault(require("fetch-jsonp"));
var PickerStyles_1 = require("./PickerStyles");
var LabelContext_1 = require("../labels/LabelContext");
var GroupContext_1 = require("../layout/GroupContext");
var Debounce_1 = require("./Debounce");
var classnames_1 = __importDefault(require("classnames"));
var PickerStyles_scss_1 = __importDefault(require("./PickerStyles.scss"));
var apiKey = '5b4fb3b9-bcd6-4503-a64c-c92f0b6c6fec';
var AbnPicker = function (_a) {
    var _b;
    var _c = _a.size, size = _c === void 0 ? 'block' : _c, props = __rest(_a, ["size"]);
    var _d = (0, react_1.useState)(null), value = _d[0], setValue = _d[1];
    var onChange = function (o) {
        if (o && !o.IsNameCurrent) {
            searchAbn(o.Abn, props.allowInactiveAbn).then(function (d) { setChangedAbn(d); });
        }
        else {
            setChangedAbn(o);
        }
    };
    var setChangedAbn = function (o) {
        setValue(o);
        props.onChange &&
            props.onChange(o != null
                ? {
                    abn: o.Abn,
                    entityName: o.Name,
                    active: o.AbnStatus == '0000000001' || o.AbnStatus == 'Active',
                    addressState: o.State,
                    addressPostcode: o.Postcode,
                }
                : null);
    };
    (0, react_1.useEffect)(function () {
        if (props.value != null && (!value || props.value != value.Abn)) {
            setValue({
                Abn: props.value,
                Name: '',
                AbnStatus: '',
                NameType: '',
                Postcode: '',
                State: '',
                IsNameCurrent: undefined,
            });
            searchAbn(props.value, props.allowInactiveAbn).then(function (d) { return onChange(d); });
        }
        else if (props.value == null && value != null) {
            onChange(null);
        }
    }, [props.value]);
    var searchAbn = function (abn, allowInactiveAbn) { return __awaiter(void 0, void 0, void 0, function () {
        var abrSearchUrl, temp, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    abrSearchUrl = "https://abr.business.gov.au/json/AbnDetails.aspx?abn=".concat(abn, "&guid=").concat(apiKey);
                    return [4, (0, fetch_jsonp_1.default)(abrSearchUrl, {
                            jsonpCallbackFunction: '',
                        })];
                case 1:
                    temp = _a.sent();
                    return [4, temp.json()];
                case 2:
                    res = _a.sent();
                    return [2, res && (allowInactiveAbn || (res === null || res === void 0 ? void 0 : res.AbnStatus) === 'Active')
                            ? {
                                Abn: res.Abn,
                                AbnStatus: res.AbnStatus,
                                Name: res.EntityName,
                                NameType: res.EntityTypeName,
                                Postcode: res.AddressPostcode,
                                State: res.AddressState,
                                IsNameCurrent: true,
                            }
                            : null];
            }
        });
    }); };
    var searchByName = function (s, allowInactiveAbn) { return __awaiter(void 0, void 0, void 0, function () {
        var abrSearchUrl, temp, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!s || s.length == 0)
                        return [2, []];
                    abrSearchUrl = "https://abr.business.gov.au/json/MatchingNames.aspx?name=".concat(s, "&maxResults=40&guid=").concat(apiKey);
                    return [4, (0, fetch_jsonp_1.default)(abrSearchUrl, {
                            jsonpCallbackFunction: '',
                            timeout: 10000,
                        })];
                case 1:
                    temp = _a.sent();
                    return [4, temp.json()];
                case 2:
                    res = _a.sent();
                    return [2, res ? (allowInactiveAbn ? res.Names : res.Names.filter(function (i) { return i.AbnStatus == '0000000001' && i.NameType == 'Entity Name'; }).slice(0, 10)) : []];
            }
        });
    }); };
    var search = function (s) { return __awaiter(void 0, void 0, void 0, function () {
        var res, temp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!/^(\d *?){11}$/.test(s)) return [3, 2];
                    return [4, searchAbn(s.replace(/ /g, ''), props.allowInactiveAbn)];
                case 1:
                    temp = _a.sent();
                    if (temp != null) {
                        res = [temp];
                    }
                    else {
                        res = [];
                    }
                    return [3, 4];
                case 2: return [4, searchByName(s, props.allowInactiveAbn)];
                case 3:
                    res = _a.sent();
                    _a.label = 4;
                case 4: return [2, res];
            }
        });
    }); };
    var labelCtx = (0, react_1.useContext)(LabelContext_1.LabelContext);
    var groupCtx = (0, react_1.useContext)(GroupContext_1.GroupContext);
    var state = labelCtx.state || props.state;
    var debouncedSearch = (0, react_1.useCallback)((0, Debounce_1.debounce)(search, 1000), []);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(PickerStyles_scss_1.default['au-picker'], (_b = {},
            _b[PickerStyles_scss_1.default["au-picker--width-".concat(size)]] = size && size != 'block',
            _b[PickerStyles_scss_1.default["au-picker--block"]] = size == 'block',
            _b), groupCtx.className, props.className) },
        react_1.default.createElement(async_1.default, { inputId: props.id || labelCtx.id, styles: (0, PickerStyles_1.reactSelectStyles)(state), className: (0, classnames_1.default)(groupCtx.className, props.className), placeholder: "Type company name or ABN...", loadOptions: debouncedSearch, value: value, onChange: onChange, getOptionLabel: function (r) { return r.Abn; }, getOptionValue: function (r) { return r.Abn; }, isClearable: true, isDisabled: props.disabled, cacheOptions: false, components: {
                Option: function (props) { return (react_1.default.createElement(react_select_1.components.Option, __assign({}, props),
                    props.data.Abn,
                    " - ",
                    props.data.Name)); },
            } })));
};
exports.AbnPicker = AbnPicker;
//# sourceMappingURL=AbnPicker.js.map